import { render } from "./Pagination.vue?vue&type=template&id=642fbcea"
import script from "./Pagination.vue?vue&type=script&lang=js"
export * from "./Pagination.vue?vue&type=script&lang=js"
script.render = render

export default script